import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import { getFormValues } from 'redux-form';
import {
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import ReferenceForm from '../modules/ReferenceForm';
import { fetchReferenceDetail } from '../modules/ReferenceDetail/actions';
import { isLoaded, getError } from '../modules/ReferenceDetail/selectors';
import { deleteReference } from '../modules/ReferenceList/actions';
import { REFERENCE_FORM_NAME } from '../modules/ReferenceForm/constants';

class EditReferencePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const { id, lang } = this.props.match.params;
    this.props.fetchReferenceDetail(id, lang);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  deleteReference = () => {
    const { id, lang } = this.props.match.params;
    this.props.deleteReference(id, lang, () => {
      this.toggle();
      this.props.history.push('/reference');
    });
  };

  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  render() {
    const { isLoaded, referenceInitialValues, match } = this.props;
    const { lang } = match.params;

    const initialValues = { ...referenceInitialValues, lang };

    return (
      <Layout>
        <Container>
          <Loader loaded={isLoaded}>
            <PageNav>
              <h1>Upravit službu</h1>
              <Button onClick={this.toggle} color="danger">
                Smazat tuto mutaci
              </Button>
            </PageNav>
            <ReferenceForm
              config={this.getConfig()}
              initialValues={initialValues}
            />
            <Modal
              isOpen={this.state.modal}
              toggle={this.toggle}
              className={this.props.className}
              backdrop={this.state.backdrop}
            >
              <ModalHeader toggle={this.toggle}>Smazat</ModalHeader>
              <ModalBody>
                Opravdu chcete tuto mutaci reference smazat?
              </ModalBody>
              <ModalFooter>
                <Button color="danger" onClick={this.deleteReference}>
                  Smazat
                </Button>
                <Button color="secondary" onClick={this.toggle}>
                  Zrušit
                </Button>
              </ModalFooter>
            </Modal>
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    referenceInitialValues: getFormValues(REFERENCE_FORM_NAME)(state),
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchReferenceDetail, deleteReference }
)(EditReferencePage);



// WEBPACK FOOTER //
// ./src/pages/EditReferencePage.js